const FP_CODE = process.env.VUE_APP_FIRSTPROMOTER_CODE;
const FP_COOKIEDOMAIN = process.env.VUE_APP_FIRSTPROMOTER_COOKIEDOMAIN;

let isInited = false;
let isEnabled = FP_CODE !== undefined && FP_COOKIEDOMAIN !== undefined && process.env.VUE_APP_ENV === 'production';

function init() {
    if (window.$FPROM) {
        return true;
    }

    /* eslint-disable */
    (function () {
        var t = document.createElement("script");
        t.type = "text/javascript";
        t.async = true;
        t.src = 'https://cdn.firstpromoter.com/fprom.js';
        t.onload = t.onreadystatechange = function () {
            var t = this.readyState;
            if (!t || "complete" == t || "loaded" == t) {
                try {
                    $FPROM.init(FP_CODE, FP_COOKIEDOMAIN);
                } catch (t) {}
            }
        };
        var e = document.getElementsByTagName("script")[0];
        e.parentNode.insertBefore(t, e);
    })();
    /* eslint-enable */

    return true;
}

/**
 * data is company data
 */
function register(data) {
    if (!isEnabled) {
        return true;
    }

    if (!isInited) {
        isInited = init();
    }

    /* eslint-disable */
    if (window.$FPROM) {
        $FPROM.trackSignup({
            email: data.company.email,
            uid: data.company.stripe_id,
        });
        return true;
    }

    const _fprom = window._fprom || [];
    window._fprom = _fprom;
    _fprom.push(["event", "signup"]);
    _fprom.push(["email", data.company.email]);
    _fprom.push(["uid", data.company.stripe_id]);
    /* eslint-enable */

    return true;
}

function enable() {
    isEnabled = true;
}

function disable() {
    isEnabled = false;
}

export default {
    enable,
    disable,
    register,
};
